/** Shared formatters & chart helpers for workspace analytics cards. */

// French locale -> thin no-break space as thousands separator ("12 480").
const intFmt = new Intl.NumberFormat('fr-FR');

export const formatInt = (value: number) => intFmt.format(value);

export const formatDecimal = (value: number) =>
    value.toLocaleString('fr-FR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    });

export type AnalyticsBarRow = {
    label: string;
    count: number;
    pct: number;
    width: number;
};
